export default "__VITE_ASSET__iyIpZX3B__"